import { type ChangeEventHandler } from 'react';
import Grid from '@material-ui/core/Grid';
import { Button, type ButtonProps } from '@shiftfinancial/design-system';

type Props = {
  label?: string;
  appearance?: ButtonProps['appearance'];
  accept: string;
  onChange: ChangeEventHandler<HTMLInputElement>;
};

export default function UploadButton({
  label = 'Add File',
  onChange,
  appearance = 'secondary',
  accept,
}: Props) {
  return (
    <Grid item>
      <input
        style={{ display: 'none' }}
        id="contained-button-file"
        multiple
        type="file"
        accept={accept}
        onChange={onChange}
        data-testid="fileInput"
      />
      <Button asChild appearance={appearance}>
        <label htmlFor="contained-button-file">{label}</label>
      </Button>
    </Grid>
  );
}
